
 $(document).ready(function () {
if($.fn.slick){
    	$('.banner_collection').slick({
          slidesToShow:1,
    		slidesToScroll: 1,
    		dots: false,    		
    		speed: 1000,        
			// appendArrows: ".slider-arrows-dots",
			arrows: true,
			 prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.2071 8.70711C23.5976 8.31658 23.5976 7.68342 23.2071 7.29289L16.8431 0.928932C16.4526 0.538408 15.8195 0.538408 15.4289 0.928932C15.0384 1.31946 15.0384 1.95262 15.4289 2.34315L21.0858 8L15.4289 13.6569C15.0384 14.0474 15.0384 14.6805 15.4289 15.0711C15.8195 15.4616 16.4526 15.4616 16.8431 15.0711L23.2071 8.70711ZM22.5 7H0V9H22.5V7Z" fill="currentColor"/></svg></div>',
            nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.792893 7.29289C0.402369 7.68342 0.402369 8.31658 0.792892 8.7071L7.15685 15.0711C7.54738 15.4616 8.18054 15.4616 8.57107 15.0711C8.96159 14.6805 8.96159 14.0474 8.57107 13.6569L2.91421 8L8.57107 2.34314C8.96159 1.95262 8.96159 1.31946 8.57107 0.928931C8.18054 0.538406 7.54738 0.538406 7.15686 0.928931L0.792893 7.29289ZM1.5 9L24 9L24 7L1.5 7L1.5 9Z" fill="#currentColor"/></svg></div>', 
      
			autoplay: true,
          infinite: true,
			autoplaySpeed: 1500
        });
}
   
   
if($.fn.slick){
    	$('.care_by').slick({
    		slidesToShow: 3,
    		slidesToScroll: 1,
    		dots: false,
    		
    		speed: 1000,        
			// appendArrows: ".slider-arrows-dots",
			arrows: true,
			 prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>',
			 nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>', 
			autoplay: true,
          infinite: true,
			autoplaySpeed: 1500,          
			responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			},
              {
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
                  dots: false,
                  arrows:true,
				}
			},
              {
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
                  dots: false,
                  arrows:true,
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
                  dots: false,
                  arrows:true,
				}
			}
			]
		});   
    }

if($.fn.slick){
  $('.brand_box').slick({
        rows: 2,
		dots: false,
		arrows: true,
		infinite: true,
		speed: 300,
		slidesToShow: 5,
		slidesToScroll: 1,
    autoplay: true,
          infinite: true,
			autoplaySpeed: 1500,
        arrows: true,
		prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>',
		nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>',
        responsive: [
    			{
    				breakpoint: 1200,
    				settings: {
    					slidesToShow: 4,
    					slidesToScroll: 1,
    				}
    			},
                {
      				breakpoint:667,
    				settings: {
    					slidesToShow:3,
    					slidesToScroll: 1,
    				}
    			},
                {
      				breakpoint:480,
    				settings: {
    					slidesToShow:2,
    					slidesToScroll: 1,
    				}
    			}
          ]
  });
}

if($.fn.slick){
    	$('.top-products').slick({
    		slidesToShow: 4,
    		slidesToScroll: 1,
    		dots: false,
    		 
    		speed: 1000,        
			// appendArrows: ".slider-arrows-dots",
			arrows: true,
			 prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>',
			 nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>', 
			autoplay: true,
          infinite: true,
			autoplaySpeed: 1500,        
			responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				}
			}, {
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
                  
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
                   
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1, 
				}
			}
			]
		});   
    }

   if($.fn.slick){
    	$('.influencer').slick({
    		slidesToShow: 6,
    		slidesToScroll: 1,
    		dots: false,
    	 
    		speed: 1000,        
			// appendArrows: ".slider-arrows-dots",
  			arrows: true,
			 prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>',
			 nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>', 
			autoplay: true,
          infinite: true,
			autoplaySpeed: 1500,        
			responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				}
			}, {
				breakpoint: 992,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1, 
				}
			},
            {
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1, 
				}
			},
            {
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1, 
				}
			}
			]
		});   
    }
   if($.fn.slick){
    	$('.beauty_tips').slick({
    		slidesToShow: 1,
    		slidesToScroll: 1,
    		dots: true,
    		 
    		speed: 1000,        
			// appendArrows: ".slider-arrows-dots",
			arrows: false,
		//	 prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>',
		//	 nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>', 
			autoplay: true,
          infinite: true,
			autoplaySpeed: 1500,        
			 
		});   
    }

  
  category_img();
   

   
   
 });



$(window).resize(function(){
    category_img();
});



function category_img(){
   if($(window).width() < 768 ){
      if($.fn.slick){
    	$('.category_img').slick({
    	 
                  slidesToShow: 1,
          		slidesToScroll: 1,
          		dots: false,
          		infinite: true,
          		speed: 1000,        
      			// appendArrows: ".slider-arrows-dots",
      			arrows: true,
      		 	 prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>',
      		 	 nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>', 
      			autoplay: false,
      			autoplaySpeed: 1500      
			 
		});   
    }
   }else{
     if($.fn.slick){
    	$('.category_img.slick-initialized ').slick("unslick");
     }
   }
}